// Dossiers de conformité par autorité de contrôle et documents attendus dans chacun.

function expectedDocuments(...labels) {
    return labels.map((label, index) => ({ key: `expected-${index + 1}`, label }));
}

export const COMPLIANCE_FOLDERS = [
    {
        key: "00-tronc-commun",
        label: "00_Généralités",
        expectedDocuments: expectedDocuments(
            "Fiche d'identité officine (licence, FINESS, SIRET, RPPS)",
            "Kbis / statuts / Ordre (inscriptions)",
            "Diplômes pharmaciens et préparateurs",
            "Organigramme et planning de présence pharmaceutique",
            "Plan des locaux",
            "Assurance RC professionnelle",
            "Liste des procédures qualité (ISO 9001) et certificat",
            "Sommaire du dossier + date de mise à jour",
            "Audit interne - Généralités (complétude et validité des pièces)"
        ),
    },
    {
        key: "01-ars-inspection-pharmacie-phisp",
        label: "01_ARS - Inspection de la pharmacie (PHISP)",
        expectedDocuments: expectedDocuments(
            "Licence et arrêtés (ouverture, transfert)",
            "Contrats de gérance / remplacement",
            "Stupéfiants : registre, inventaire annuel, procédure, coffre",
            "Chaîne du froid : procédure, relevés, anomalies",
            "Retraits de lots et alertes ANSM : registre de traitement",
            "Périmés et retours",
            "Sérialisation (attestation France MVO)",
            "Traçabilité MDS",
            "Préparations : préparatoire, registre, sous-traitance",
            "Ordonnancier / registre des délivrances",
            "Pharmacovigilance / matériovigilance",
            "Vaccination, TROD : procédures, traçabilité, formations",
            "Hygiène, nettoyage, déchets (DASRI, Cyclamed, Dastri)",
            "Site internet / vente en ligne",
            "Rapports d'inspection ARS antérieurs + plans d'action",
            "Audit interne - ARS (grille type inspection, rapport, écarts, actions)"
        ),
        children: [
            {
                key: "01-ars-dispensation-ehpad-residences",
                label: "Dispensation EHPAD / résidences",
                expectedDocuments: expectedDocuments(
                    "Conventions par établissement",
                    "Procédure et traçabilité PDA",
                    "Livraison et chaîne du froid",
                    "Dotations, stupéfiants en établissement",
                    "Coordination avec médecin coordonnateur"
                ),
            },
        ],
    },
    {
        key: "02-ordre-pharmaciens-crop-section-a",
        label: "02_Ordre des pharmaciens (CROP section A)",
        expectedDocuments: expectedDocuments(
            "Inscriptions titulaire et adjoints, cotisations",
            "Déclarations de remplacement",
            "Contrats de travail des pharmaciens",
            "Déontologie : affichage, confidentialité",
            "Conventions de partenariat",
            "Publicité et communication",
            "Courriers échangés avec l'Ordre",
            "Audit interne - Ordre (conformité déontologique, inscriptions à jour)"
        ),
    },
    {
        key: "03-ansm",
        label: "03_ANSM",
        expectedDocuments: expectedDocuments(
            "Déclarations de pharmacovigilance",
            "Traitement des alertes et rappels de lots",
            "Préparations (fiches de fabrication, matières premières)",
            "Médicaments sous surveillance renforcée / AAP",
            "Ruptures et importations",
            "Audit interne - ANSM (délais de traitement des alertes, traçabilité)"
        ),
    },
    {
        key: "04-cpam-assurance-maladie",
        label: "04_CPAM / Assurance maladie",
        expectedDocuments: expectedDocuments(
            "Convention nationale + avenants",
            "Télétransmission : SESAM-Vitale, SCOR",
            "Procédure de facturation et contrôle des ordonnances",
            "Archivage des ordonnances",
            "Rejets, indus, réclamations",
            "Tiers payant : justificatifs de droits",
            "Substitution générique / biosimilaires",
            "ROSP : indicateurs et justificatifs",
            "Entretiens pharmaceutiques, BPM",
            "Facturation EHPAD",
            "Courriers et contrôles CPAM antérieurs",
            "Audit interne - CPAM (échantillon d'ordonnances, taux de rejet, conformité facturation)"
        ),
    },
    {
        key: "05-dgccrf-ddpp",
        label: "05_DGCCRF / DDPP",
        expectedDocuments: expectedDocuments(
            "Affichage des prix et honoraires",
            "Médicaments en accès libre : liste et prix",
            "Publicité, promotions, fidélité",
            "Parapharmacie, cosmétiques, compléments alimentaires",
            "Traçabilité fournisseurs",
            "Étiquetage et DLUO",
            "Conditions générales de vente",
            "Dispositifs médicaux (marquage CE, notices)",
            "Balance / matériel de pesée",
            "Audit interne - DGCCRF (contrôle affichage, étiquetage, DLUO en rayon)"
        ),
    },
    {
        key: "06-inspection-travail-dreets",
        label: "06_Inspection du travail (DREETS)",
        expectedDocuments: expectedDocuments(
            "Registre unique du personnel",
            "Contrats de travail, avenants, fiches de poste",
            "Convention collective",
            "Durée du travail : plannings, décomptes, repos",
            "DUERP et plan d'actions",
            "Visites médicales du travail",
            "Formations sécurité, habilitations",
            "Affichages obligatoires",
            "Règlement intérieur (si applicable)",
            "Entretiens professionnels",
            "Audit interne - Travail (affichages, DUERP, visites médicales à jour)"
        ),
    },
    {
        key: "07-urssaf",
        label: "07_URSSAF",
        expectedDocuments: expectedDocuments(
            "DSN et justificatifs",
            "Bulletins de paie",
            "Contrats de travail et DPAE",
            "Mutuelle et prévoyance",
            "Frais professionnels et avantages en nature",
            "Contrôles antérieurs",
            "Audit interne - URSSAF (cohérence paie / contrats / DSN)"
        ),
    },
    {
        key: "08-dgfip",
        label: "08_DGFiP",
        expectedDocuments: expectedDocuments(
            "Liasses fiscales et bilans",
            "Déclarations TVA",
            "Journal de caisse, attestation logiciel de caisse",
            "Factures fournisseurs",
            "CFE / taxes locales",
            "Correspondance fiscale",
            "Audit interne - Fiscal (avec expert-comptable : complétude, délais)"
        ),
    },
    {
        key: "09-cnil-rgpd",
        label: "09_CNIL / RGPD",
        expectedDocuments: expectedDocuments(
            "Registre des traitements",
            "Information clientèle",
            "Contrat LGO et hébergeur HDS",
            "Gestion des accès (CPS, mots de passe, habilitations)",
            "Sauvegardes : procédure et preuves",
            "Vidéosurveillance",
            "Procédure de violation de données",
            "DPO ou référent",
            "Audit interne - RGPD (revue des accès, test de restauration de sauvegarde)"
        ),
    },
    {
        key: "10-securite-sdis-mairie",
        label: "10_Sécurité / SDIS / Mairie",
        expectedDocuments: expectedDocuments(
            "Registre de sécurité",
            "Contrôles électrique, extincteurs, alarme",
            "PV de commission de sécurité",
            "Accessibilité PMR",
            "Enseigne / domaine public",
            "Audit interne - Sécurité (issues, extincteurs, registre à jour)"
        ),
    },
    {
        key: "11-douanes",
        label: "11_Douanes",
        expectedDocuments: expectedDocuments(
            "Alcool : statut, DRM",
            "Précurseurs de drogues",
            "Produits soumis à accises",
            "Audit interne - Douanes (stocks vs registres)"
        ),
    },
    {
        key: "12-organisme-certificateur-iso-9001",
        label: "12_Organisme certificateur ISO 9001",
        expectedDocuments: expectedDocuments(
            "Manuel qualité, cartographie des processus",
            "Revues de direction",
            "Actions correctives, amélioration continue",
            "Réclamations et satisfaction",
            "Rapports d'audit externe",
            "Audit interne - Système qualité (programme annuel, rapports, synthèse des 11 audits sectoriels)"
        ),
    },
    {
        key: "13-sacem-spre",
        label: "13_SACEM / SPRE",
        expectedDocuments: expectedDocuments(
            "Contrat de diffusion SACEM (ou attestation de non-diffusion)",
            "Factures et justificatifs de paiement annuels",
            "Déclaration des sources de diffusion (radio, streaming, TV, téléphone)",
            "Contrat du fournisseur de musique d'ambiance",
            "Surface de vente déclarée (base de calcul de la redevance)",
            "Courriers échangés avec la SACEM",
            "Audit interne - SACEM (sources réellement diffusées vs déclarées, paiement à jour)"
        ),
    },
];
